export default "__VITE_ASSET__JHEY_Hdf__"